import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FormInput } from "../../../../Components";
import { WebRoutes } from "../../../../Constants";
import { hasValue } from "../../../../Helpers/validations/common";
import { getPackageByBarcodeRequest } from "../../../../Backend/SchoolsRequests";
import "./PackageScanModal.scss";

export function PackageScanModal({ school, ...props }) {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const [barcode, setBarcode] = useState("");
  const [barcodeState, setBarcodeState] = useState(1);

  const [barcodeInfo, setBarcodeInfo] = useState({
    barcode: "",
    classNumber: null,
    completeDate: null,
    id: "",
    isCompleted: false,
    schoolScanComplete: false,
    schoolScanUser: "",
    userId: "",
    year: 0,
    student: {
      id: "",
      currentBarcode: null,
      userName: "",
      firstName: "",
      preposition: "",
      lastName: "",
      email: "",
      softEmail: "",
      postalCode: "",
      adress: "",
      country: null,
      houseNumber: "",
      houseNumberAddition: "",
      city: "",
      returnedId: "",
      extraProperties: null,
      showAdvice: false,
      isEnabled: false,
      havePendingSchools: false,
      isExternalUser: false,
      role: null,
      roleNames: [],
      customerId: null,
      schoolName: "",
      schoolNumber: null,
      schoolId: null,
    },
  });

  const inputId = "barcodeInputId";

  useEffect(() => {
    if (hasValue(barcode) && barcode.length === 7) {
      filterPackagesByBarcode(barcode);
    }
  }, [barcode]);

  useEffect(() => {
    if (barcodeState === 1) {
      const element = document.getElementById(inputId);
      if (element) {
        element.focus();
      }
    }
  }, [barcodeState]);

  const filterPackagesByBarcode = async (barcode) => {
    const resp = await getPackageByBarcodeRequest(
      school.schoolId,
      barcode,
      school.year
    );

    if (resp.success) {
      const found = resp.data.list[0];
      if (found && hasValue(found.id)) {
        navigate(
          WebRoutes.PackageReturns.replace(":schoolId", school.schoolId)
            .replace(":packageId", found.id)
            .replace(":year", school.year)
        );
        // setBarcodeInfo(found);
        // setBarcodeState(2);
      } else {
        setBarcodeState(3);
      }
    }
  };

  const info = [
    { key: t("Barcode"), value: barcodeInfo.barcode },
    { key: t("Name"), value: barcodeInfo.student.firstName },
    { key: t("Preposition"), value: barcodeInfo.student.preposition },
    { key: t("LastName"), value: barcodeInfo.student.lastName },
  ];

  const renderBody = () => {
    switch (barcodeState) {
      case 1:
        return (
          <div className="input-wrapper">
            <FormInput
              inputId={inputId}
              placeholder=""
              type="text"
              value={barcode}
              change={(x) => {
                setBarcode(x.replace(/\D/g, ""));
              }}
              otherProperties={{
                maxLength: 13,
                minLength: 13,
              }}
            />
          </div>
        );
      case 2:
        return (
          <div className="package-info-wrapper">
            <div className="subtitle">{t("PackageInformation")}</div>
            {info.map((x) => (
              <div className="info-row" key={"info-" + x.key}>
                <span className="key">{x.key}:</span>
                <span className="value">{x.value}</span>
              </div>
            ))}
          </div>
        );
      case 3:
        return (
          <div className="package-info-wrapper">
            <div className="subtitle">{t("PackageInformation")}</div>
            <div className="error-wrapper">
              <span className="message">{t("PackageNotFound")}</span>
              <span
                className="again"
                onClick={() => {
                  setBarcode("");
                  setBarcodeState(1);
                }}
              >
                {t("TryAgain")}
              </span>
            </div>
          </div>
        );
    }
  };

  return (
    <Modal {...props} centered dialogClassName="package-scan-modal">
      <Modal.Header closeButton>
        <span className="title">{t("Package")}</span>
      </Modal.Header>
      <Modal.Body className="package-scan-content">
        <div className="subtitle">{t("PackageScanModal")}</div>
        <div className="text">{t("PackageScanModalText")}</div>
        <div className="info-wrapper">{renderBody()}</div>
        {/* <div className="buttons-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Cancel")}
          </Button>
          <Button
            className="button-save"
            disabled={barcodeState !== 2}
            onClick={() =>
              navigate(
                WebRoutes.PackageReturns.replace(
                  ":schoolId",
                  school.schoolId
                ).replace(":packageId", barcodeInfo.id)
              )
            }
          >
            {t("OpenPackage")}
          </Button>
        </div> */}
      </Modal.Body>
    </Modal>
  );
}
